import 'twin.macro';
import 'styled-components/macro';
import { useEffect } from 'react';

import { Button } from 'play/atoms/button/Button';
import { ReactComponent as GotoArrow } from 'play/organisms/splash-screen/assets/goto-arrow.svg';
import { SplashLayout } from 'play/templates/splash-layout/SplashLayout';

import { useTrackAmplitudeEvent } from '../../../support/amplitude/amplitudeEvent';
import { SplashScreenChallenge, SplashScreenChallengeList } from './SplashScreenChallengeList';

export interface SplashScreenProps {
  challenges?: SplashScreenChallenge[];
  teaser?: string;
  title?: string;
  onLaunch: () => void;
}

export const SplashScreen = ({ challenges, teaser, title, onLaunch }: SplashScreenProps) => {
  const trackAmplitudeEvent = useTrackAmplitudeEvent();
  const onLaunchClicked = () => {
    trackAmplitudeEvent({
      name: 'Lab - Splash - Launched track',
    });
    onLaunch();
  };

  useEffect(() => {
    trackAmplitudeEvent({
      name: 'Lab - Splash - Landed',
    });
  }, [trackAmplitudeEvent]);

  return (
    <SplashLayout
      bottomLeft="Hands-On Lab"
      bottomRight={
        <Button onClick={onLaunchClicked} tw="flex flex-row items-center gap-1">
          Launch
          <GotoArrow />
        </Button>
      }
    >
      <div tw="flex flex-grow justify-center items-center overflow-hidden px-4">
        <div tw="flex flex-col justify-center max-w-3xl w-full h-full">
          {title && <h1 tw="display-1 mb-2">{title}</h1>}
          {teaser && <p tw="intro mb-4 text-gray-5">{teaser}</p>}
          {challenges && <SplashScreenChallengeList challenges={challenges} />}
        </div>
      </div>
    </SplashLayout>
  );
};
